var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '.fullwidth-container' }),expression:"{ el: '.fullwidth-container' }"}],staticClass:"headvisual--scroll-indicator btn",attrs:{"aria-label":"Nach unten Scrollen","data-aos":"fade-up","data-aos-duration":"1100","data-aos-delay":"1100"}},[_c('MouseIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }